module.exports = __webpack_public_path__ + "img/homepro0.05ee3ba1.png";